module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"h1":"Partnership","text":"Get 20 to 40% for your invited users.<br />\\nSimply share this link and receive 20 to 40% of all purchases by invited users\\n","rules":"The amount of reward depends on the total amount of purchases of the invited users\\nand increases by 2% for every $500\\n"}}')
  delete Component.options._Ctor
}
